export function appendMiscellaneous(reagents, scores, options = {}) {
  const { logger, miscellaneous = {} } = options;
  const { highVoltage, dustRisk, reactionTime, temperature, gasLines, pressure, overheadStirring } = miscellaneous

  scores.other = {}

  if (dustRisk) {
    scores.other.dustRisk = 4;
  }

  switch (reactionTime) {
    case 'daytime':
      scores.other.reactionTime = 0;
      break;
    case 'overnight':
      scores.other.reactionTime = 2;
      break;
    default:
      logger.error(`Unknown reactionTime: ${reactionTime}`);
  }

  switch (temperature) {
    case '<100':
      scores.other.temperature = 0;
      break;
    case '100-200':
      scores.other.temperature = 1;
      break;
    case 'extreme':
      scores.other.temperature = 2;
      break;
    default:
      logger.error(`Unknown temperature: ${temperature}`);
  }

  switch (gasLines.inert) {
    case 'none':
      scores.other.gasLinesInert = 0;
      break;
    case '<20':
      scores.other.gasLinesInert = 0;
      break;
    case '20-40':
      scores.other.gasLinesInert = 1;
      break;
    case '>40':
      scores.other.gasLinesInert = 2;
      break;
    default:
      logger.error(`Unknown gasLines.inert: ${gasLines.inert}`);
  }

  switch (gasLines.reactive) {
    case 'none':
      scores.other.gasLinesReactive = 0;
      break;
    case '<20':
      scores.other.gasLinesReactive = 2;
      break;
    case '20-40':
      scores.other.gasLinesReactive = 3;
      break;
    case '>40':
      scores.other.gasLinesReactive = 4;
      break;
    default:
      logger.error(`Unknown gasLines.inert: ${gasLines.reactive}`);
  }

  switch (pressure.parrLow) {
    case 'none':
      scores.other.pressureParrLow = 0;
      break;
    case '1-20':
      scores.other.pressureParrLow = 1;
      break;
    case '20-100':
      scores.other.pressureParrLow = 2;
      break;
    case '>100':
      scores.other.pressureParrLow = 3;
      break;
    default:
      logger.error(`Unknown pressure.parrLow: ${pressure.parrLow}`);
  }

  switch (pressure.parrHigh) {
    case 'none':
      scores.other.pressureParrHigh = 0;
      break;
    case '1-2':
      scores.other.pressureParrHigh = 1;
      break;
    case '2-5':
      scores.other.pressureParrHigh = 2;
      break;
    case '>10':
      scores.other.pressureParrHigh = 3;
      break;
    default:
      logger.error(`Unknown pressure.parrHigh: ${pressure.parrHigh}`);
  }

  switch (pressure.pRated) {
    case 'none':
      scores.other.pressurePRated = 0;
      break;
    case '1-2':
      scores.other.pressurePRated = 1;
      break;
    case '2-5':
      scores.other.pressurePRated = 2;
      break;
    case '>5':
      scores.other.pressurePRated = 3;
      break;
    default:
      logger.error(`Unknown pressure.pRated: ${pressure.pRated}`);
  }

  switch (pressure.nonRated) {
    case 'none':
      scores.other.pressureNonRated = 0;
      break;
    case 'yes':
      scores.other.pressureNonRated = 100;
      break;
    default:
      logger.error(`Unknown pressure.nonRated: ${pressure.nonRated}`);
  }

  switch (overheadStirring) {
    case 'none':
      scores.other.overheadStirring = 0;
      break;
    case 'yes':
      scores.other.overheadStirring = 21
      break;
    default:
      logger.error(`Unknown overheadStirring: ${overheadStirring}`);
  }

  switch (highVoltage) {
    case 'none':
      scores.other.highVoltage = 0;
      break;
    case 'yes':
      scores.other.highVoltage = 100;
      break;
    default:
      logger.error(`Unknown highVoltage: ${highVoltage}`);
  }

}